export default __webpack_public_path__ + "static/proberts-f57e5a4bc158ea2c65ccf51a38d489bb.png";